'use strict';

import versioner from '../versioner';
import noop from './noop';
import noResponse from './no_response';
import noShopNoDisband from './no_shop_no_disband';
import yesShopNoDisband from './yes_shop_no_disband';
import yesShopYesDisband from './yes_shop_yes_disband';
import betterShop from './better_shop';
import manualDispatch from './manual_dispatch';

versioner['noop'] = {process: noop};

for (var version of [
	'no_response',
	'daupler_qa_oakland_general',
	'daupler_qa_durham',
	'daupler_qa_olympia',
	'qav2',
	'durham_noop',
	'event_autocollected',
	'',
]) {
	versioner[version] = {process: noResponse};
}

for (var version of [
	// 'standard_context_response_v2',
	// 'klamath_falls_sewer_treatment_ah',
	// 'klamath_falls_water_dist_ah',
	// 'klamath_falls_water_billing_ah',
	// 'klamath_falls_sewer_collections_ah',
	// 'klamath_falls_traffic_ah',
	// 'alliance_ralls_co_sewer_ah',
	// 'alliance_ralls_co_water_ah',
	// 'alliance_ralls_co_sewer_daytime',
	// 'alliance_ralls_co_water_daytime',
	// 'alliance_elsberry_sewer_ah',
	// 'alliance_elsberry_water_ah',
	// 'oakland_general_investigate_ah',
	// 'oakland_general_investigate_sewer_ah',
	// 'oakland_general_field_service_ah',
	// 'greeley_sewer_ah',
	// 'greeley_water_ah',
	// 'lake_havasu_water_ah',
	// 'lake_havasu_water_ah_default',
	// 'lake_havasu_water_ah_backup',
	// 'santa_barbara_general_ah',
	// 'santa_barbara_water_ah',
	// 'generic_sewer_v1',
	// 'olympia_general_ah',
	// 'nob_hill_water_ah',
	// 'oakland_training',
	// 'mwsd_co',
	// 'dsrsd_ah',
	// 'moses_lake_wa_water_ah',
	// 'moses_lake_wa_sewer_ah',
	// 'moses_lake_wa_streets_ah',
	// 'moses_lake_wa_stormwater_ah',
	// 'moses_lake_wa_water_billing_ah',
	// 'pinellas_park_fl_water_ah',
	// 'pinellas_park_fl_sewer_ah',
	// 'pinellas_park_fl_utility_billing_ah',
	// 'pinellas_park_fl_pw_ah',
	// 'lander_wy_water_ah',
	// 'lander_wy_sewer_ah',
	// 'lander_wy_streets_ah',
	// 'lander_wy_parks_ah',
	// 'lander_wy_maintenance_ah',
	// 'lander_wy_buildings_ah',
	// 'lander_wy_cemeteries_ah',
	// 'olathe_water_v2_ah',
	// 'olathe_sewer_v2_ah',
	// 'olathe_streets_v2_ah',
	// 'olathe_traffic_v2_ah',
	// 'olathe_facilities_v2_ah',
	// 'olathe_stormwater_v2_ah',
	// 'oakland_sewer_ah',
	// 'oakland_sewer_investigation',
	// 'oakland_trees_ah',
	// 'oakland_facilities_ah',
	// 'oakland_electric_ah',
	// 'oakland_general_standby_ah',
	// 'berea_ky_water_ah',
	// 'berea_ky_sewer_ah',
	// 'berea_ky_electric_ah',
	// 'berea_ky_billing_ah',
	// 'monroe_la_water_ah',
	// 'monroe_la_meter_services_ah',
	// 'stpeters_mo_water_ah',
	// 'stpeters_mo_sewer_ah',
	// 'stpeters_mo_stormwater_ah',
	// 'south_adams_co_water_ah',
	// 'south_adams_co_sewer_ah',
	// 'ottawa_ks_sewer_ah',
	// 'ottawa_ks_water_ah',
	// 'ottawa_ks_electric_ah',
	// 'ottawa_ks_electric_alarm_ah',
	// 'ottawa_ks_turn_ons_ah',
	// 'opelika_al_water_ah',
	// 'rwrwa_water_ah',
	// 'rwrwa_sewer_ah',
	// 'santa_clarita_ca_ah',
	// 'louisburg_ks_general_ah',
	// 'vallejo_ca_ah',
	// 'kirkwood_mo_electric_ah',
	// 'hillsboro_mo_water_ah',
	// 'hillsboro_mo_sewer_ah',
	// 'hillsboro_mo_streets_ah',
	// 'kittitas_wa_pud_electric_ah',
	// 'midland_county_mi_roads_ah',
	// 'mccleary_wa_power_ah',
	// 'mccleary_wa_pw_ah',
	// 'opd5_nv_electric_ah',
	// 'durham_pump_stations',
	// 'bargersville_in_water_ah',
	// 'bargersville_in_sewer_ah',
	// 'bargersville_in_streets_ah',
	// 'cheney_wa_light_ah',
	// 'cheney_wa_water_ah',
	// 'cheney_wa_wastewater_ah',
	// 'cheney_wa_streets_ah',
	// 'middletown_de_electric_ah',
	// 'middletown_de_water_sewer_ah',
	// 'middletown_de_municipal_ah',
	// 'middletown_de_maintenance_ah',
	// 'middletown_de_locates_ah',
	// 'peculiar_mo_pw_ah',
	// 'peculiar_mo_sewer_ah',
	// 'bamberg_sc_general_ah',
	// 'anderson_in_water_ah',
	// 'pawhuska_ok_general_ah',
	// 'palmdale_ca_general_ah',
	// 'franklin_pud_wa_general_ah',
	// 'flux_alarm_group_v1',
	// 'hca_pa_water_ah',
	// 'utility_locate_v1',
	// 'ug_streets',
]) {
	versioner[version] = {process: noShopNoDisband};
}

for (var version of [
	'klamath_falls_streets_ah',
]) {
	versioner[version] = {process: yesShopNoDisband};
}

for (var version of [
]) {
	versioner[version] = {process: yesShopYesDisband};
}

for (var version of [
	'roxborough_sewer_ah',
	'roxborough_water_ah',
]) {
	versioner[version] = {process: betterShop};
}

for (var version of [
	'jcw_manual_dispatch',
]) {
	versioner[version] = {process: manualDispatch};
}

const MODULE_NAME = 'daupler.incidents.versions.standardResponse';

export default MODULE_NAME;
